var eServicesSelectedCats = [];

var clientSideSortCurrentMethod;
var clientSideSortMethods = {};

jQuery(document).ready(function($) {

	if(!($('.client-side-sortable').length))
		return;

	$("#client-side-sort-select option").each(function () {
		var sortName = $(this).text();
		var sortIndex = $(this).data("cc-sort-index");
		var sortAt = $(this).data("cc-sort-at");
		clientSideSortMethods[sortIndex] = {"name":sortName, "sortAt":sortAt};
		clientSideSortCurrentMethod = clientSideSortMethods[1];
	});

	parseURLAndApplyFiltering();

	$("#client-side-sort-select").change(function () {
		var optionSelected = $("option:selected", this);
		var selectedSortID = $(optionSelected).data("cc-sort-index");
		clientSideSortCurrentMethod = clientSideSortMethods[selectedSortID];
		updateQueryStringParam("sort", selectedSortID);

		updateEServicesSorting();
	});

	$(".eservice-add-tag").click(function(e){
		e.preventDefault();
		var catid = $(this).data("eservice-cat-id");
		//console.log(catid);

		var addedChip = $("div.active-tags a.tag-chip.remove-tag[data-eservice-cat-id='"+catid+"']");
		if(addedChip.length)
		{
			//console.log("Already added!");
			return;
		}

		eServicesSelectedCats.push(catid);
		var newListItem = '<li><a data-eservice-cat-id="'+catid+'" href="#" class="tag-chip remove-tag">'+$(this).data("eservice-cat-name")+'</a></li>';
		$("div.active-tags ul.slidee").append(newListItem);

		$(this).parent().hide();

		updateQueryStringParam("cat", eServicesSelectedCats.join());
		updateEServicesUI();
		updateEServicesSorting();
	});

	//Listener for the selected categories.
	$('.eservice-archive-page div.active-tags').delegate('a.tag-chip.remove-tag', 'click', function(e) {
		e.preventDefault();
		var catid = $(this).data("eservice-cat-id");
		//console.log("Removing chip with id: "+catid);
		var index = eServicesSelectedCats.indexOf(catid);
		if(index > -1)
			eServicesSelectedCats.splice(index, 1);
		updateQueryStringParam("cat", eServicesSelectedCats.join());
		$(this).parent().remove();
		$("div.add-tag-container a.tag-chip.add-tag[data-eservice-cat-id='"+catid+"']").parent().show();
		updateEServicesUI();
		updateEServicesSorting();
		//$("div.active-tags a.tag-chip.remove-tag[data-eservice-cat-id='"+catid+"']").remove();
	});

	function parseURLAndApplyFiltering(){

		var sorting = $.url("?sort");
		var cats = $.url('?cat');

		if (cats != null) {
			var steps = cats.split(',');
			for (var i = 0; i < steps.length; i++) {
				if ($.isNumeric(steps[i])) {
					var catid = parseInt(steps[i]);
					eServicesSelectedCats.push(catid);
					var addedChip = $("div.add-tag-container a.tag-chip[data-eservice-cat-id='"+catid+"']");
					var newListItem = '<li><a data-eservice-cat-id="'+catid+'" href="#" class="tag-chip remove-tag">'+$(addedChip).data("eservice-cat-name")+'</a></li>';
					$(addedChip).parent().hide();
					$("div.active-tags ul.slidee").append(newListItem);
				}
			}
		}
		if (sorting != null)
		{
			clientSideSortCurrentMethod = clientSideSortMethods[sorting];
			$("#client-side-sort-select option").filter(function() {
				//may want to use $.trim in here
				return $(this).data("cc-sort-index") == sorting;
			}).prop('selected', true);
			//$("#client-side-sort-select option[data-cc-sort-index='"+sorting+"']").change();
		}
		updateEServicesUI();
		updateEServicesSorting();
	}
	function updateEServicesSorting()
	{
		//console.log("updateEServicesSorting: "+clientSideSortCurrentMethod["sortAt"]);

		$(".clientSideSearchEl").sort(function(a, b){
			return ($(b).data(clientSideSortCurrentMethod["sortAt"])) < ($(a).data(clientSideSortCurrentMethod["sortAt"])) ? 1 : -1;
		}).appendTo('.client-side-sortable');
	}
	function updateEServicesUI()
	{
		if(eServicesSelectedCats.length<1)
		{
			$("#no-services-notice").show();
			$('.clientSideSearchEl').show();
		}
		else
		{
			$("#no-services-notice").hide();
			$('.clientSideSearchEl').hide();
			var index;
			var lenght = eServicesSelectedCats.length;
			for (index = 0; index < lenght; ++index) {
				var loopedID = (eServicesSelectedCats[index]).toString();
				$('.clientSideSearchEl').filter('[data-eservice-cat-id="'+loopedID+'"]').show();
			}
		}

		updateCountedObjects();
	}
});


function updateCountedObjects()
{
	$ = jQuery;
	if(!($('.client-side-count').length))
		return;
	var numberOfActiveServices = $(".clientSideSearchEl:visible").length;
	$(".client-side-count").text(" "+numberOfActiveServices+" träffar");
}

